<template>
	<div>
	<h5> 
	{{response}}
	</h5>
	</div>
</template>

<script>
import axios from 'axios';
export default {
	components: {
		axios,
	},
	
	data() {
		return {
			messageType: this.$route.params.messageType,
			message: this.$route.params.message,
			response: "",
		}
	},
	methods: {
		callAPI: function() {
			this.response = "Contacting server ...";	
			if (this.messageType == "contact_message") {
				this.response = "Thank you for your message.";	
			} else if ( this.messageType == "job_application") {
				this.response = "Thank you for submitting your application.";	
			} else {
				this.response = "Thanks you for contacting us.";	
			}
			
			if (this.messageType) {
				axios.post(
					'/message', 
					this.$route.params.message,
					{headers: {
						'Content-Type': 'application/json',
						'Access-Control-Allow-Origin': '*',
				//		'Access-Control-Allow-Headers': 'Content-Type,Access-Control-Allow-Origin,Access-Control-Allow-Headers'
					}}
				)
				.then( function(response) {
				})
				.catch(function(error) {
				});
			}
		}
	},
	mounted () {
		this.callAPI();
	}
}
</script>


